// COLORS PALETTE FOR AUREN

export const indraEnabled = false
export const boardIcon = '#000000'

export const muiPaletteOverride = {
  text: {
    primary: '#000',
    secondary: '#000'
  },
  primary:   {
    main:         '#E2211C',
    contrastText: '#fff',
  },
  secondary: {
    main:         '#ffc107',
    contrastText: '#212121',
  },
}

export const success = {
  light: '#91e573',
  main: '#00e676',
  dark: '#30d786',
}

export const buttonColor = null
export const toolbarColor =  null
export const percentageProcessTable =  '#E00012'
export const percentageProcessTableNumber =  '#E2211C'

//actionButton Primary Colors
export const actionButtonBackgroundColor =  '#E2211C'
export const actionButtonBackgroundHoverColor =  '#E00012'
export const actionButtonBorderColor = 'transparent'
export const actionButtonFontColor =  '#FFFFFF'
export const actionButtonFontHoverColor = '#FFFFFF'

//actionButton Secondary Colors
export const actionButtonBackgroundSecondaryColor = '#FFC107'
export const actionButtonBackgroundHoverSecondaryColor = '#FF8F00'
export const actionButtonBorderSecondaryColor = 'transparent'
export const actionButtonFontSecondaryColor = '#000000'
export const actionButtonFontHoverSecondaryColor = '#000000'

//Button Primary Colors
export const ButtonBackgroundColor =  '#E2211C'
export const ButtonBackgroundHoverColor =  '#E00012'
export const ButtonBorderColor = '00BCD4'
export const ButtonFontColor =  '#FFFFFF'
export const ButtonFontHoverColor = '#FFFFFF'

export const ButtonNotRaisedBackgroundColor =  'transparent'
export const ButtonNotRaisedBackgroundHoverColor =  '#E6F5F7'
export const ButtonNotRaisedBorderColor = 'transparent'
export const ButtonNotRaisedFontColor =  '#E2211C'
export const ButtonNotRaisedFontHoverColor = '#E2211C'

//Button Secondary Colors
export const ButtonBackgroundSecondaryColor = '#FFC107'
export const ButtonBackgroundHoverSecondaryColor = '#FF8F00'
export const ButtonBorderSecondaryColor = 'transparent'
export const ButtonFontSecondaryColor = '#000000'
export const ButtonFontHoverSecondaryColor = '#000000'

//Titles and Headings Font Color
export const headerBarColor = '#E2211C'
export const title = '#212121'
export const headerTable = '#757575'
export const dataTable = '#282828'
export const whiteText = '#FFFFFF'

//Pie Chart Colors
export const FinishedItemsColor = '#7EAA55'
export const PendingItemsColor =  '#B02418'
export const OnGoingItemsColor = '#F6C242'


// WEBPACK FOOTER //
// ./src/theme.js